import { render, staticRenderFns } from "./InvoiceCard.vue?vue&type=template&id=58643702&scoped=true"
import script from "./InvoiceCard.vue?vue&type=script&lang=js"
export * from "./InvoiceCard.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCard.vue?vue&type=style&index=0&id=58643702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58643702",
  null
  
)

export default component.exports